<template>
  <div id="PageCSRDCheck">
    <SectionCSRDCheck />
    <SectionComplexity />
    <SectionCSRD />
  </div>
</template>

<script setup lang="ts">
import SectionCSRD from '@/views/components/sections/SectionCSRD.vue'
import SectionComplexity from '@/views/components/sections/SectionComplexity.vue'
import SectionCSRDCheck from './sections/SectionCSRDCheck.vue'
import { useSeo, getBreadcrumbStructuredData } from '@/composables/useSeo'
import { getSeoConfig } from '@/config/seo'

// SEO Configuration
useSeo(
  getSeoConfig('csrdCheck'),
  getBreadcrumbStructuredData([
    { name: 'Home', url: 'https://sustainalyse.com/' },
    { name: 'CSRD Check', url: 'https://sustainalyse.com/csrd-check' }
  ])
)
</script>

<style lang="scss" scoped>
#PageCSRDCheck {
  min-height: 100vh;
}
</style>
